/**
 * @Author chenguanbin
 * @Date 2020-06-01 14:06:18
 * @Desc 设备管理接口
 */
import http from './instance'

export default {
  /**
   * @author chenguanbin
   * @date 2020-06-01 14:07:58
   * @desc 查询传感器
   */
  querySensorPage(payload) {
    return http.post('/v1/sensor/page', payload)
  },

  /**
   * @author chenguanbin
   * @date 2020-06-01 14:08:42
   * @desc 新增传感器
   */
  addSensor(payload) {
    return http.post('/v1/sensor/addChannel', payload)
  },

  /**
   * @author chenguanbin
   * @date 2020-06-04 16:24:24
   * @desc 根据编号查询传感器数据
   */
  querySensor(indexCode) {
    return http.post('/v1/sensor/queryChannelByIndexCode', {
      indexCode
    })
  },

  /**
   * @author chenguanbin
   * @date 2020-06-01 14:08:42
   * @desc 更新传感器
   */
  updateSensor(payload) {
    return http.post('/v1/sensor/updateChannel', payload)
  },

  /**
   * @author chenguanbin
   * @date 2020-06-01 14:08:42
   * @desc 删除传感器
   */
  deleteSensor(payload) {
    return http.post('/v1/sensor/deleteChannel', payload)
  },

  /**
   * @author chenguanbin
   * @date 2020-06-01 14:08:42
   * @desc 校验同一个设备下通道号是否已经存在
   */
  validateChannelNum(payload) {
    return http.post('/v1/sensor/validateChannelNum', payload)
  },

  /**
   * @author chenguanbin
   * @date 2020-06-01 16:02:58
   * @desc 获取所属设备列表
   */
  querySensorSerial(orgId) {
    return http.post('/v1/device/queryDevicesByOrgCode', {
      orgId
    })
  },

  /**
   * @author chenguanbin
   * @date 2020-06-01 14:08:42
   * @desc 获取传感器类型列表
   */
  queryDevicesByOrgCode() {
    return http.post('/v1/dictionary/queryDicInfoByType', {
      id: 'common.sensor'
    })
  }
}
